import { Builder } from '@builder.io/react';
import { BUILDER_DIVIDER_NAMES } from '../BuilderComponentsName';
import { LocationsBanner } from '../../components/shared/dividers/LocationsBanner';

Builder.registerComponent(LocationsBanner, {
    name: BUILDER_DIVIDER_NAMES.LocationsBanner,
});
